import { PHASE } from "../../routeConfig";
import isTruthy from "../../utils/isTruthy";
import useAppSelector from "../../hooks/useAppSelector";
export default function useGetPrefillInitialRoute(issuerType) {
    var hasVehicles = useAppSelector(function (state) { return state.unlinkedApplication.auto.vehicles.length > 0; });
    var hasValidVehicles = useAppSelector(function (state) {
        var vehicles = state.unlinkedApplication.auto.vehicles;
        var validVehicles = vehicles.every(function (veh) { var _a, _b; return ((_a = veh.trim) === null || _a === void 0 ? void 0 : _a.vin) || ((_b = veh.trim) === null || _b === void 0 ? void 0 : _b.vinStub); });
        return vehicles.length > 0 && validVehicles;
    });
    var hasPolicyHolderData = useAppSelector(function (state) {
        var policyHolderOperator = state.unlinkedApplication.auto.drivers[0];
        var policyHolderData = [
            policyHolderOperator === null || policyHolderOperator === void 0 ? void 0 : policyHolderOperator.firstName,
            policyHolderOperator === null || policyHolderOperator === void 0 ? void 0 : policyHolderOperator.lastName,
            policyHolderOperator === null || policyHolderOperator === void 0 ? void 0 : policyHolderOperator.dateOfBirth,
            policyHolderOperator === null || policyHolderOperator === void 0 ? void 0 : policyHolderOperator.gender,
            policyHolderOperator === null || policyHolderOperator === void 0 ? void 0 : policyHolderOperator.maritalStatus,
        ];
        return policyHolderData.every(isTruthy);
    });
    var jornayaLeadId = useAppSelector(function (state) { return state.applicant.jornayaLeadId.prefill; });
    if (issuerType === "home") {
        return PHASE.UNLINKED_APPLICATION_HOMEOWNERS_PROPERTY_ADDRESS;
    }
    if (!hasVehicles) {
        return PHASE.UNLINKED_APPLICATION_AUTO_VEHICLES_EDIT_YEAR;
    }
    if (!hasValidVehicles) {
        return PHASE.UNLINKED_APPLICATION_AUTO_VEHICLES;
    }
    if (!hasPolicyHolderData) {
        return PHASE.UNLINKED_APPLICATION_AUTO_DRIVERS;
    }
    if (!jornayaLeadId) {
        return PHASE.UNLINKED_APPLICATION_AUTO_POLICY_HOLDER;
    }
    return PHASE.QUOTE_LOADING;
}
